import { render, staticRenderFns } from "./render_textarea_textarea.vue?vue&type=template&id=002aaa40&scoped=true&"
import script from "./render_textarea_textarea.vue?vue&type=script&lang=js&"
export * from "./render_textarea_textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002aaa40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002aaa40')) {
      api.createRecord('002aaa40', component.options)
    } else {
      api.reload('002aaa40', component.options)
    }
    module.hot.accept("./render_textarea_textarea.vue?vue&type=template&id=002aaa40&scoped=true&", function () {
      api.rerender('002aaa40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_textarea_textarea.vue"
export default component.exports